import {
  RTADDNEWADDRESS,
  RTPRIVACYPOLICY,
  RTCOMPLETEORDER,
  RTADDRESSLIST,
  RTREGISTER,
  RTDAITONN,
  RTProfile,
  RTSignin,
  RTMAP,
  RTOTP,
} from "../screens/sc-profile";
import {
  PT_COMPLETEORDERS,
  PT_ADDNEWADDRESS,
  PT_PRIVACYPOLICY,
  PT_ADDRESSLIST,
  PT_REGISTER,
  PT_DAITONN,
  PT_PROFILE,
  PT_SIGNIN,
  PT_MAP,
  PT_OTP,
} from "./paths/pt-profile";
import { KEY_GENERATOR } from "../../functions/funtion";
import { Route } from "react-router-dom";

let RouteArray = [
  [
    <Route key={KEY_GENERATOR()} path={PT_PROFILE} element={<RTProfile />} />,
    <Route key={KEY_GENERATOR()} path={PT_SIGNIN} element={<RTSignin />} />,
    <Route key={KEY_GENERATOR()} path={PT_OTP} element={<RTOTP />} />,
    <Route key={KEY_GENERATOR()} path={PT_REGISTER} element={<RTREGISTER />} />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_ADDRESSLIST}
      element={<RTADDRESSLIST />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_ADDNEWADDRESS}
      element={<RTADDNEWADDRESS />}
    />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_COMPLETEORDERS}
      element={<RTCOMPLETEORDER />}
    />,
    <Route key={KEY_GENERATOR()} path={PT_MAP} element={<RTMAP />} />,
    <Route
      key={KEY_GENERATOR()}
      path={PT_PRIVACYPOLICY}
      element={<RTPRIVACYPOLICY />}
    />,
    <Route key={KEY_GENERATOR()} path={PT_DAITONN} element={<RTDAITONN />} />,
  ],
];

export default RouteArray;
